import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter, withLatestFrom } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectBoardUserAdded, selectBoardUserAdding, selectBoardUserEdited, selectBoardUserEditing, selectCurrentDevice, selectCurrentDeviceBoardUsersInfo, selectCurrentDeviceCommands, selectCurrentDeviceInfo, selectCurrentDeviceModel, selectGroupsAll } from "src/app/store/device/device.selector";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { DeviceModel } from "src/app/model/device-model";
import { Command } from "src/app/model/command";
import { BoardUser, buttonNumber, humanReadableToKbCode, isBadge, isCodeTypeGroupable, isRollingCode, kbCodeToHumanReadable } from "src/app/model/board-user";
import { BoardUsersInfo } from "src/app/model/board-users-info";
import { ECodeTypes, ERemoteModels, KEYBOARD_MAX, KEYBOARD_MAXLEN, KEYBOARD_MIN } from "src/app/conf/board-users";
import { EAutomationClass, isAutomationClassGroupable } from "src/app/conf/automation-class";
import { TranslateService } from "@ngx-translate/core";
import { EDeviceModel } from "src/app/conf/device-models";
import { MenuItem } from "primeng/api";
import { ConnectedAutomations, Device } from "src/app/model/device";
import { RBE_24_COMMAND_ID_AUTOMATION_1, RBE_24_COMMAND_ID_AUTOMATION_2, RBE_24_COMMAND_ID_AUTOMATION_3, RBE_24_COMMAND_ID_AUTOMATION_4 } from "src/app/conf/rbe24230";
import { StandardDynamicComponent, StandardNewValidator, StandardNewValidatorStepTabs, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { CAGroup } from "src/app/model/control-access";
import moment from "moment";
import { DeviceInfo } from "src/app/model/device-info";
import { MINFWVER_ACSCHEDULES_RBE24 } from "src/app/conf/control-access";
import { CustomValidators } from "src/app/validators/custom.validators";
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	templateUrl: './board-user.dialog.component.html',
})

export class BoardUserDialogComponent implements OnInit, OnDestroy {
	boardUserAdding: boolean;
	boardUserAdding$: Observable<boolean | undefined>;
	boardUserAddingSub: Subscription | undefined;

	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;

	boardUserEditing: boolean;
	boardUserEditing$: Observable<boolean | undefined>;
	boardUserEditingSub: Subscription | undefined;

	boardUserAdded$: Observable<boolean | undefined>;
	boardUserAddedSub: Subscription | undefined;
	boardUserEdited$: Observable<boolean | undefined>;
	boardUserEditedSub: Subscription | undefined;

	boardUserInfo$: Observable<BoardUsersInfo | undefined>;
	boardUserInfoSub: Subscription | undefined;

	deviceCurrentModel$: Observable<DeviceModel | undefined>;
	deviceCurrentCommands$: Observable<Command[] | undefined>;

	connectedAutomation$: Observable<ConnectedAutomations[] | undefined>;
	connectedAutomationSub: Subscription | undefined;

	deviceInfo: DeviceInfo;
	deviceInfo$: Observable<DeviceInfo | undefined>;
	deviceInfoSub: Subscription | undefined;

	groupsAll$: Observable<CAGroup[] | undefined>;
	groupsAllSub: Subscription | undefined;
	listGroup: CAGroup[];

	typeSub: Subscription | undefined;

	boardUserForm: FormGroup;
	connectedAutomation: ConnectedAutomations[];

	deviceModel: DeviceModel;
	boardUsersInfo: BoardUsersInfo;
	boardUser: BoardUser;
	isCodeGroup: boolean;

	items: MenuItem[] | undefined;
	activeIndex: number = 0;

	models: any[];
	codeMin = null;
	codeMax = null;
	codePlaceholder = 'AAAABBBBCCCC000011';
	codeLength = 18;


	buTypes: any[] = [];
	buItems: any[] = [];
	buType: any;
	buTypeDescription: string;
	buCode: string;
	buMode: number;
	buModeBitmask: any[];
	buName = '';
	buGroupName = '';
	buPosition = 0;
	currentDeviceCommands: Command[];

	finalType: string;

	codeTypes: string[] = [];
	codeType: string;

	modelTypes: string[] = [];
	modelType: string;

	keyboardTypes: string[] = [];
	keyboardType: string;

	transponderTypes: string[] = [];
	transponderType: string;

	otherModelTypes: string[] = [];  // va aggiunto: KLT, Struass klt
	otherModelType: string;

	itemsType = 'combo';
	edit = false;

	screenWidth: number;

	saving = false;

	GroupId: number;
	DtFrom: string;
	DtTo: string;
	enableTemporaryAccess: boolean = false;


	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		private fb: FormBuilder,
		public config: DynamicDialogConfig,
		private translate: TranslateService
	) {
		this.DtFrom = moment().format('yyyy-MM-DDT00:00');
		this.DtTo = moment().format('yyyy-MM-DDT00:00');
		if (config.data !== undefined) {
			if (config.data.deviceModel !== undefined && config.data.deviceModel !== null) {
				this.deviceModel = config.data.deviceModel;
			} else {
				this.deviceModel = new DeviceModel;
			}

			if (this.config.data.boardUsersInfo !== undefined && this.config.data.boardUsersInfo !== null) {
				this.boardUsersInfo = config.data.boardUsersInfo;
			} else {
				this.boardUsersInfo = undefined;
			}

			if (this.config.data.boardUser !== undefined && this.config.data.boardUser !== null) {
				this.boardUser = config.data.boardUser;
				this.enableTemporaryAccess = this.isTemporary(this.boardUser);
				if (this.enableTemporaryAccess) {
					this.DtFrom = moment(this.boardUser.DateFrom).format('yyyy-MM-DDT00:00');
					this.DtTo = moment(this.boardUser.DateTo).format('yyyy-MM-DDT00:00');
				}
				this.GroupId = this.boardUser.GroupId;
				this.edit = true;
			} else {
				this.boardUser = new BoardUser;
				this.edit = false;
			}
			if (this.config.data.isCodeGroup !== undefined && this.config.data.isCodeGroup !== null) {
				this.isCodeGroup = this.config.data.isCodeGroup;
			} else {
				this.isCodeGroup = false;
			}
		}

		this.finalType = '';

		this.codeType = '';
		this.codeTypes.push('BOARD_USER');
		this.codeTypes.push('KEYPAD');
		this.codeTypes.push('TRANSPONDER');

		this.modelType = '';
		this.modelTypes.push('Rolling code');
		this.modelTypes.push('TOP');
		this.modelTypes.push('TAM');
		this.modelTypes.push('Twin');
		this.modelTypes.push('New Fixed Code');

		this.keyboardType = '';
		this.keyboardTypes.push('Keypad');

		this.transponderType = '';
		this.transponderTypes.push('Transponder');

		this.otherModelType = '';
		this.otherModelTypes.push('KLT');
		this.otherModelTypes.push('STRAUSS KLT');

		this.initSelectors();
	}

	initSelectors(): void {
		this.boardUserAdding$ = this.store.select(selectBoardUserAdding);
		this.boardUserEditing$ = this.store.select(selectBoardUserEditing);

		this.boardUserAdded$ = this.store.select(selectBoardUserAdded);
		this.boardUserEdited$ = this.store.select(selectBoardUserEdited);

		this.boardUserInfo$ = this.store.select(selectCurrentDeviceBoardUsersInfo);

		this.deviceCurrentModel$ = this.store.select(selectCurrentDeviceModel);
		this.deviceCurrentCommands$ = this.store.select(selectCurrentDeviceCommands);
		this.device$ = this.store.select(selectCurrentDevice);
		this.groupsAll$ = this.store.select(selectGroupsAll);
		this.deviceInfo$ = this.store.select(selectCurrentDeviceInfo);
	}

	ngOnInit(): void {
		this.buForm();
		this.subscribeAll();

		if (this.edit) {
			this.setCodeTypeEdit();
		} else {
			this.setCodeType('BOARD_USER');
			this.setModelType('Rolling code');
			this.finalType = 'Rolling code';
		}
		this.setOtherModelType('KLT');

		this.onResize();

		StandardNewValidator.setFirstCompile(true);

		StandardNewValidatorStepTabs.firstTabfields = [];
		StandardNewValidatorStepTabs.secondTabfields = [];
		StandardNewValidatorStepTabs.thirdTabfields = [];

		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.groupName, 2);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.name, 2);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.mode, 2);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.typeDescription, 2);
		StandardNewValidatorStepTabs.pushFieldOnTab(this.f.code, 2);

		if (this.edit) {
			this.changeActiveTabClick(2);
		}
	}

	ngOnDestroy(): void {
		this.boardUserAddedSub?.unsubscribe();
		this.boardUserEditedSub?.unsubscribe();
		this.boardUserInfoSub?.unsubscribe();
		this.typeSub?.unsubscribe();
		this.boardUserAddingSub?.unsubscribe();
		this.boardUserEditingSub?.unsubscribe();
		this.deviceSub?.unsubscribe();
		this.groupsAllSub?.unsubscribe();
		this.deviceInfoSub?.unsubscribe();
	}

	subscribeAll(): void {
		this.deviceInfoSub = this.deviceInfo$.pipe(filter(d => !!d))
			.subscribe(currentDeviceInfo => {
				this.deviceInfo = currentDeviceInfo;
			});
		this.boardUserAddingSub = this.boardUserAdding$
			.subscribe(
				(adding) => {
					this.saving = adding;
					this.boardUserAdding = adding;
				}
			);
		this.boardUserEditingSub = this.boardUserEditing$
			.subscribe(
				(editing) => {
					this.saving = editing;
					this.boardUserEditing = editing;
				}
			);
		this.boardUserAddedSub = this.boardUserAdded$
			.pipe(filter(edit => !!edit))
			.subscribe(() => {
				this.resetClose();
			}
			);
		this.boardUserEditedSub = this.boardUserEdited$
			.pipe(filter(edit => !!edit))
			.subscribe(() => {
				this.resetClose();
			}
			);
		this.deviceSub = this.device$.pipe(filter(d => !!d))
			.subscribe(currentDevice => {
				if (currentDevice !== undefined) {
					this.connectedAutomation = currentDevice.ConnectedAutomations;
				} else {
					this.connectedAutomation = [];
				}
			});
		this.groupsAllSub = this.groupsAll$.subscribe(listGroup => {
			this.listGroup = listGroup;
		});
		this.boardUserInfoSub = this.boardUserInfo$
			.pipe(
				filter(bui => !!bui),
				withLatestFrom(this.store.select(selectCurrentDeviceModel), this.store.select(selectCurrentDeviceCommands))
			)
			.subscribe(([boardUsersInfo, deviceModel, deviceCommands]) => {
				this.buTypes = boardUsersInfo.Types;
				if (this.edit) {
					if (this.ttsModel()) {
						this.buTypes = this.buTypes.filter(buType => buType.Name !== ERemoteModels.TYPE_TWIN);
					} else if (this.twinModel()) {
						this.buTypes = this.buTypes.filter(buType => buType.Name !== ERemoteModels.TYPE_TTS_FIXED_CODE);
					} else if (this.topSportModel()) {
						this.buTypes = this.buTypes.filter(buType => buType.Name !== ERemoteModels.TYPE_TWIN);
					}
				}
				this.buItems = boardUsersInfo.ControlItem.Items;
				this.itemsType = boardUsersInfo.ControlItem.Type;
				this.deviceModel = deviceModel;
				this.currentDeviceCommands = deviceCommands;

				if (this.isRbe24230(this.deviceModel) || this.isRbe4(this.deviceModel)) {
					for (const command of this.buItems) {
						command.DescriptionItem = this.getDescriptionItem(command);
					}
				}
				this.setupForm();
				if (this.isRbe24230Model() && this.isFunctionControlAccessSuppor()) {
					this.store.dispatch(DeviceActions.getGroupsAll());
				}
			}
			);
	}

	isRbe24230Model(): boolean {
		return this.isRbe24230(this.deviceModel);
	}

	goToIndexCheckandActive(direction: string) {
		if (this.codeType === 'BOARD_USER') {
			this.changeActiveTabClick(1);
		} else {
			if (direction === 'next') {
				this.changeActiveTabClick(2);
			} else { // 'back'
				this.changeActiveTabClick(0);
			}
		}
	}

	changeActiveTabClick(index: number) {
		// if (this.canSwitchTab()) {
		this.activeIndex = index;
	}

	twinModel(): boolean {
		return [ERemoteModels.TW2EE.toString(), ERemoteModels.TW4EE.toString()].includes(
			this.config.data.boardUser.TypeDescription
		);
	}

	ttsModel(): boolean {
		return this.config.data.boardUser.TypeDescription === ERemoteModels.TTS44FKS;
	}

	topSportModel(): boolean {
		return [ERemoteModels.TOP42FGN.toString(), ERemoteModels.TOP44FGN.toString(), ERemoteModels.TOPD4FRN.toString()].includes(
			this.config.data.boardUser.TypeDescription
		);
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.boardUserDialogReset());
		this.dialogRef.close('success');
	}

	setupForm(): void {
		this.onTypeChange();
		if (this.edit) {
			this.decodeBuData();
		} else {
			this.setDefaultBuMode();
		}
		this.setDefaultBuType();
		this.setForm();
	}

	decodeBuData(): void {
		this.buType = this.buTypes.find(t => t.Id === this.boardUser.Type);
		this.buTypeDescription = this.boardUser.TypeDescription ? this.boardUser.TypeDescription : this.buType.Items[0];
		if (this.config.data.boardUser.Type === ECodeTypes.CODE_TYPE_KEYBOARD) { // convert keyboard code to human readable
			this.buCode = kbCodeToHumanReadable(this.config.data.boardUser.Code);
		} else {
			this.buCode = this.config.data.boardUser.Code;
		}
		if (this.itemsType === 'bitmask') {
			this.selectFunctions(this.config.data.boardUser);
		} else {
			this.buMode = this.config.data.boardUser.Mode;
		}

		this.buMode = this.config.data.boardUser.Mode;
		this.buName = this.config.data.boardUser.Name ? this.config.data.boardUser.Name : this.translate.instant('NO_NAME');
		this.buGroupName = this.config.data.boardUser.GroupName ? this.config.data.boardUser.GroupName : this.translate.instant('NO_NAME');
		this.buPosition = this.config.data.boardUser.Position + 1;
	}

	selectFunctions(boardUser: BoardUser) {
		let mode = boardUser.Mode;
		const items: any[] = [];
		for (let i = 7; i >= 4; i--) {
			if (Math.floor(mode / (2 ** i)) === 1) {
				const cmd = this.buItems.find(item => item.Value === (2 ** i));
				if (cmd) {
					items.unshift(2 ** i);
				}
				mode = mode - (2 ** i);
			}
		}
		if (this.isRbe24230(this.deviceModel)) {
			if (boardUser.Autom1Cmd !== null) {
				items.push(boardUser.Autom1Cmd);
			}
			if (boardUser.Autom2Cmd !== null) {
				items.push(boardUser.Autom2Cmd);
			}
			if (boardUser.Autom3Cmd !== null) {
				items.push(boardUser.Autom3Cmd);
			}
			if (boardUser.Autom4Cmd !== null) {
				items.push(boardUser.Autom4Cmd);
			}
		}
		this.buModeBitmask = items;
	}

	setDefaultBuMode(): void {
		const items = [...this.buItems];
		items.sort((a, b) => a.Value - b.Value);
		const defaultItem = items.find(i => i.Value > 0);
		this.buMode = defaultItem.Value;
	}

	buForm(): void {
		this.boardUserForm = this.fb.group({
			name: [this.buName, this.config.data.isCodeGroup ? null : Validators.required],
			groupName: [this.buGroupName, this.config.data.isCodeGroup ? Validators.required : null],
			code: [
				{ value: this.buCode, disabled: this.edit },
				[Validators.minLength(18), Validators.maxLength(18), Validators.pattern('[0-9a-fA-F]+'), Validators.required]
			],
			type: [{ value: this.buType, disabled: this.edit }, Validators.required],
			typeDescription: [{ value: this.buTypeDescription, disabled: this.buTypeEnabled }, Validators.required], // MODELboard
			mode: [this.buMode, this.isAClassGroupable && this.itemsType === 'combo' ? Validators.required : null],
			modeBitmask: [this.buModeBitmask, this.isAClassGroupable && this.itemsType === 'bitmask' ? Validators.required : null],
			position: [{ value: this.buPosition, disabled: true }],
			buttonNumber: [{ value: this.buttonNumber, disabled: true }],
			Group: [{ value: this.GroupId }],
			StartDate: [{ value: this.DtFrom === undefined ? null : moment(this.DtFrom).toDate() }],
			EndDate: [{ value: this.DtTo === undefined ? null : moment(this.DtTo).toDate() }],
			EnableTemporaryAccess: [{ value: this.enableTemporaryAccess }],
		});
		this.boardUserForm.addValidators(CustomValidators.checkCorrectOnlyDateEnable('EnableTemporaryAccess', 'StartDate', 'EndDate'));
	}

	get buTypeEnabled(): boolean {
		return this.edit && !(this.config.data.isCodeGroup || this.isBadge);
	}

	setForm(): void {
		if (this.boardUserForm !== undefined && this.boardUserForm !== null && this.buItems !== undefined) {
			this.boardUserForm.controls["name"].setValue(this.buName);
			this.boardUserForm.controls["groupName"].setValue(this.buGroupName);
			this.boardUserForm.controls["code"].setValue(this.buCode);
			this.boardUserForm.controls["type"].setValue(this.buType);
			this.boardUserForm.controls["typeDescription"].setValue(this.buTypeDescription);
			this.boardUserForm.controls["mode"].setValue(this.buMode);
			this.boardUserForm.controls["modeBitmask"].setValue(this.buModeBitmask);
			this.boardUserForm.controls["position"].setValue(this.buPosition);
			this.boardUserForm.controls["buttonNumber"].setValue(this.buttonNumber);
			this.boardUserForm.controls["Group"].setValue(this.GroupId);
			this.boardUserForm.controls["StartDate"].setValue(this.DtFrom === undefined ? null : moment(this.DtFrom).toDate());
			this.boardUserForm.controls["EndDate"].setValue(this.DtTo === undefined ? null : moment(this.DtTo).toDate());
			this.boardUserForm.controls["EnableTemporaryAccess"].setValue(this.enableTemporaryAccess);
			this.disableListCommand(this.buItems);
		}
	}

	setDefaultBuType(): void {
		if (this.buType === undefined) {
			const rc = this.buTypes.filter(buType => buType.Name === ERemoteModels.TYPE_ROLLING);
			if (!rc || rc.length === 0) {
				this.buType = this.buTypes[0];
			} else {
				this.buType = rc[0];
			}
		}
	}

	onTypeChange(): void {
		this.typeSub = this.f.type.valueChanges.subscribe(typeval => {
			if (this.edit) {
				this.f.code.disable();
			} else {
				this.f.code.enable();
			}
			if (typeval.Id === ECodeTypes.CODE_TYPE_KEYBOARD) { // validate code TYPE KEYBOARD
				this.f.typeDescription.disable();
				this.codeMin = KEYBOARD_MIN;
				this.codeMax = KEYBOARD_MIN;
				this.codePlaceholder = '0-99999999';
				this.codeLength = KEYBOARD_MAXLEN;
				this.f.code.setValidators([Validators.min(KEYBOARD_MIN), Validators.max(KEYBOARD_MAX),
				Validators.pattern('[0-9]+'), Validators.required]);
				this.f.code.markAsTouched();
			} else if (typeval.Id === ECodeTypes.CODE_TYPE_TRANSPONDER) { // validate code TYPE KEYBOARD
				this.f.typeDescription.enable();
				this.codeMin = null;
				this.codeMax = null;
				this.codePlaceholder = 'AAAABBBBCCCC000011';
				this.codeLength = 18;
				this.f.code.setValidators([Validators.minLength(5),
				Validators.maxLength(18), Validators.pattern('[0-9a-fA-F]+'), Validators.required]);
				this.f.code.markAsTouched();
			} else { // VALIDATE CODE TYPE OTHERS
				this.f.typeDescription.enable();
				this.codeMin = null;
				this.codeMax = null;
				this.codePlaceholder = 'AAAABBBBCCCC000011';
				this.codeLength = 18;
				this.f.code.setValidators([Validators.minLength(18),
				Validators.maxLength(18), Validators.pattern('[0-9a-fA-F]+'), Validators.required]);
				this.f.code.markAsTouched();
			}
			if (!this.edit) {
				// adding
				if (this.isBadge) {
					this.f.typeDescription.setValue(this.f.type.value.Items[0]); // force TST01
					this.f.typeDescription.enable();
				} else {
					this.f.typeDescription.setValue(undefined);
					this.f.typeDescription.disable();
				}
			}
		});
	}

	filter(buItems: any[]): any {
		const rItem = [];
		if (this.isRbe24230(this.deviceModel)) {
			for (const command of buItems) {
				if (command.Value > 255) {
					if (this.visibleAutomationsCommand(command)) {
						rItem.push(command);
					}
				} else {
					rItem.push(command);
				}
			}
			return rItem;
		} else if (this.isRbe4(this.deviceModel)) {
			for (const command of buItems) {
				rItem.push(command);
			}
			return rItem;
		} {
			return buItems;
		}
	}

	visibleAutomationsCommand(item: any): boolean {
		let crpItemId = null;
		switch (item.Value) {
			case 256:
			case 257:
			case 258:
			case 259:
				crpItemId = 1;
				break;
			case 260:
			case 261:
			case 262:
			case 263:
				crpItemId = 2;
				break;
			case 264:
			case 265:
			case 266:
			case 267:
				crpItemId = 3;
				break;
			case 268:
			case 269:
			case 270:
			case 271:
				crpItemId = 4;
				break;
		}
		if (crpItemId !== null && this.connectedAutomation !== undefined) {
			const automa = this.connectedAutomation.find(aut => aut.CrpItemId === crpItemId);
			if (automa !== undefined) {
				return true;
			}
		}
		return false;
	}

	canSwitchTab(): boolean {
		return StandardNewValidatorStepTabs.canSwitchTab(this.activeIndex);
	}

	getColorFirstTab(): string {
		this.canSwitchTab();
		return StandardNewValidatorStepTabs.getColorFirstTab();
	}

	getColorSecondTab(): string {
		return StandardNewValidatorStepTabs.getColorSecondTab(this.activeIndex);
	}

	getColorThirdTab(): string {
		return StandardNewValidatorStepTabs.getColorThirdTab(this.activeIndex);
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.boardUserForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.boardUserForm.get(key).errors;
			if (controlErrors != null) {
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		/*if (this.isAClassGroupable && this.itemsType === 'combo' && this.f.mode.value === 1) {
			this.f.mode.errors = { required: true };
		}*/
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const boardUser = Object.assign(new BoardUser(), this.config.data.boardUser);

		boardUser.Code = this.convertCode(this.f.code.value, this.f.type.value.Id);
		boardUser.Type = this.f.type.value.Id;
		if (boardUser.Type !== ECodeTypes.CODE_TYPE_KEYBOARD && boardUser.Code.length < 18) {
			const num0 = 18 - boardUser.Code.length;
			for (let i = 0; i < num0; i++) {
				boardUser.Code = '0' + boardUser.Code;
			}
		}
		if (boardUser.Type !== ECodeTypes.CODE_TYPE_TRANSPONDER && boardUser.Code.length < 18) {
			const num0 = 18 - boardUser.Code.length;
			for (let i = 0; i < num0; i++) {
				boardUser.Code = '0' + boardUser.Code;
			}
		}

		boardUser.TypeDescription = this.f.typeDescription.value || this.fromInfo(this.f.type.value);

		if (this.isRbe24230(this.deviceModel)) {
			boardUser.Autom1Cmd = this.getAutomationCommand1();
			boardUser.Autom2Cmd = this.getAutomationCommand2();
			boardUser.Autom3Cmd = this.getAutomationCommand3();
			boardUser.Autom4Cmd = this.getAutomationCommand4();
		}
		if (!this.isCodeGroup) {
			boardUser.Name = this.f.name.value;
			boardUser.State = 170;
			if (this.itemsType === 'bitmask') {
				boardUser.Mode = this.isAClassGroupable ? this.generateBitmaskModeValue() : 0;
			} else {
				boardUser.Mode = this.isAClassGroupable ? this.f.mode.value : 0;
			}
		} else {
			boardUser.GroupName = this.f.groupName.value;
			//boardUser.CodeBase = codeBase(boardUser); old
			boardUser.CodeBase = boardUser.Code.substring(2);  //CHANGE TEST NOT NECESSARY TO CONVERT
		}
		if (this.isRbe24230(this.deviceModel) && boardUser.Autom1Cmd) { // Modify for set on Mode that automation1 is used
			boardUser.Mode = boardUser.Mode + 1;
		}
		if (this.isRbe24230(this.deviceModel) && boardUser.Autom2Cmd) { // Modify for set on Mode that automation2 is used
			boardUser.Mode = boardUser.Mode + 2;
		}
		if (this.isRbe24230(this.deviceModel) && boardUser.Autom3Cmd) { // Modify for set on Mode that automation3 is used
			boardUser.Mode = boardUser.Mode + 4;
		}
		if (this.isRbe24230(this.deviceModel) && boardUser.Autom4Cmd) { // Modify for set on Mode that automation4 is used
			boardUser.Mode = boardUser.Mode + 8;
		}
		if (this.isRbe24230Model()) {
			boardUser.GroupId = this.f.Group.value;
			if (this.f.EnableTemporaryAccess.value) {
				boardUser.DateFrom = moment(this.f.StartDate.value).format('yyyy-MM-DD 00:00');
				boardUser.DateTo = moment(this.f.EndDate.value).format('yyyy-MM-DD 23:59');
			} else {
				boardUser.DateFrom = null;
				boardUser.DateTo = null;
			}
		}
		if (typeof boardUser.Position !== 'undefined') {
			this.store.dispatch(DeviceActions.editBoardUser({ boardUser, isCodeGroup: this.config.data.isCodeGroup }));
			this.analyticsEditBu();
		} else { // adding device
			this.store.dispatch(DeviceActions.addBoardUser({ boardUser }));
			this.analyticsNewBu();
		}
	}

	analyticsNewBu() {
		const addGroup = this.f.Group && this.f.Group.value != null ? true : false;
		const tempAccess = this.f.EnableTemporaryAccess && this.f.EnableTemporaryAccess.value ? this.f.EnableTemporaryAccess.value : false;
		const productBoardName = this.deviceModel && this.deviceModel.ProductBoardName ? this.deviceModel.ProductBoardName : '';
		const pageTitle = (productBoardName === 'RBEPLUS') ? 'RBEPLUS | BoardUsers' : 'BoardUsers';
		const buParams = { page_title: pageTitle, buType: this.codeType, buAddGroup: addGroup, buTempAccess: tempAccess };
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'new_boarduser_submited', params: buParams }));
		}, 2000);
	}

	analyticsEditBu() {
		const addGroup = this.f.Group && this.f.Group.value != null ? true : false;
		const tempAccess = this.f.EnableTemporaryAccess && this.f.EnableTemporaryAccess.value ? this.f.EnableTemporaryAccess.value : false;
		const productBoardName = this.deviceModel && this.deviceModel.ProductBoardName ? this.deviceModel.ProductBoardName : '';
		const pageTitle = (productBoardName === 'RBEPLUS') ? 'RBEPLUS | BoardUsers' : 'BoardUsers';
		const buParams = { page_title: pageTitle, buType: this.codeType, buAddGroup: addGroup, buTempAccess: tempAccess };
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'edit_boarduser_submited', params: buParams }));
		}, 2000);
	}

	getAutomationCommand1(): number {
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const c of this.f.modeBitmask.value) {
				if (RBE_24_COMMAND_ID_AUTOMATION_1.includes(c)) {
					return c;
				}
			}
		}
		return null;
	}

	getAutomationCommand2(): number {
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const c of this.f.modeBitmask.value) {
				if (RBE_24_COMMAND_ID_AUTOMATION_2.includes(c)) {
					return c;
				}
			}
		}
		return null;
	}
	getAutomationCommand3(): number {
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const c of this.f.modeBitmask.value) {
				if (RBE_24_COMMAND_ID_AUTOMATION_3.includes(c)) {
					return c;
				}
			}
		}
		return null;
	}

	getAutomationCommand4(): number {
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const c of this.f.modeBitmask.value) {
				if (RBE_24_COMMAND_ID_AUTOMATION_4.includes(c)) {
					return c;
				}
			}
		}
		return null;
	}

	generateBitmaskModeValue(): number {
		let mode = 0;
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const item of this.f.modeBitmask.value) {
				if (item < 256) {
					mode = mode + item;
				}
			}
		}
		return mode;
	}

	fromInfo(typeValue: any): string {
		if (typeValue.Id === ECodeTypes.CODE_TYPE_TWIN_TTS_FIXED && typeValue.Name !== 'Twin') {
			return ERemoteModels.TOP42FGN;
		}
		if (typeValue.Id === ECodeTypes.CODE_TYPE_ROLLING) {
			return ERemoteModels.TOP44RBN;
		}
		return (typeValue.Items) ? (typeValue.Items[0]) : '';
	}

	convertCode(code: string, type: number): string {
		if (type === ECodeTypes.CODE_TYPE_KEYBOARD) {
			return humanReadableToKbCode(code);
		} else {
			return code;
		}
	}

	getDescriptionItem(item: any): string {
		if (item === undefined) {
			return '';
		}
		if (this.isRbe4(this.deviceModel) || this.isRbe24230(this.deviceModel)) {
			for (const command of this.currentDeviceCommands) {
				if (item.Value === 16 && command.Id === 144) {
					return command.Default === command.Description ?
						item.Description : command.Description + ' (' + item.Description + ')';
				}
				if (item.Value === 32 && command.Id === 145) {
					return command.Default === command.Description ?
						item.Description : command.Description + ' (' + item.Description + ')';
				}
				if (item.Value === 64 && command.Id === 146) {
					return command.Default === command.Description ?
						item.Description : command.Description + ' (' + item.Description + ')';
				}
				if (item.Value === 128 && command.Id === 147) {
					return command.Default === command.Description ?
						item.Description : command.Description + ' (' + item.Description + ')';
				}
				if (item.Value > 255) {
					return this.getDescriptionAutomationsCommand(item);
				}
			}
			return item.Description;
		} else {
			return item.Description;
		}
	}

	getDescriptionAutomationsCommand(item: any): string {
		let crpItemId = null;
		switch (item.Value) {
			case 256:
			case 257:
			case 258:
			case 259:
				crpItemId = 1;
				break;
			case 260:
			case 261:
			case 262:
			case 263:
				crpItemId = 2;
				break;
			case 264:
			case 265:
			case 266:
			case 267:
				crpItemId = 3;
				break;
			case 268:
			case 269:
			case 270:
			case 271:
				crpItemId = 4;
				break;
		}
		if (crpItemId !== null && this.connectedAutomation !== undefined) {
			const automa = this.connectedAutomation.find(aut => aut.CrpItemId === crpItemId);
			if (automa !== undefined) {
				return automa.Name + ' - ' + item.Description;
			}
		}
		return item.Description;
	}

	isRbe4(device: DeviceModel): boolean {
		return device !== undefined && (device.Id === EDeviceModel.RBE4 || device.Id === EDeviceModel.RBE4030 || device.Id === EDeviceModel.RBE4230 ||
			device.Id === EDeviceModel.GEN_RBE4);
	}

	isRbe24230(device: DeviceModel): boolean {
		return device !== undefined && (device.Id === EDeviceModel.RBE24230 || device.Id === EDeviceModel.RBE230 ||
			device.Id === EDeviceModel.RBE24 || device.Id === EDeviceModel.GEN_RBE24230);
	}

	get f(): any {
		return this.boardUserForm.controls;
	}

	get isCodeTypeGroupable(): boolean {
		if (this.deviceModel && this.config.data.boardUser) {
			return isAutomationClassGroupable(this.deviceModel.BoardClass) &&
				isCodeTypeGroupable(this.config.data.boardUser.Type);
		}
		return false;
	}

	get buttonNumber(): number {
		if (this.config.data.boardUser) {
			return buttonNumber(this.config.data.boardUser);
		} else {
			return -1;
		}
	}

	get isAClassGroupable(): boolean {
		return this.deviceModel && isAutomationClassGroupable(this.deviceModel.BoardClass);
	}

	get isRc(): boolean {
		if (this.config.data.boardUser) {
			return isRollingCode(this.config.data.boardUser.Type);
		}
		return false;
	}

	get isBadge(): boolean {
		if (this.config.data && this.config.data.boardUser) {
			if (!isBadge(this.config.data.boardUser.Type)) {
				this.boardUserForm?.get('typeDescription').disable();
			}
			// editing
			return isBadge(this.config.data.boardUser.Type);
		} else {
			// adding
			if (!isBadge(this.f.type.value.Id) || !this.f.type.value) {
				this.boardUserForm?.get('typeDescription').disable();
			}
			if (!this.f.type.value) {
				return false;
			}
			return isBadge(this.f.type.value.Id);
		}
	}

	get codeTypeCanBeDetected(): boolean {
		if (this.deviceModel && this.config.data.boardUser) {
			const aclass = this.deviceModel.BoardClass;
			const codeType = this.config.data.boardUser.Type;
			// For now SHUTTERS (zvl2) can only detect ROLLING CODE and TOP
			return (
				aclass !== EAutomationClass.CLASS_SHUTTER ||
				(aclass === EAutomationClass.CLASS_SHUTTER &&
					(codeType === ECodeTypes.CODE_TYPE_ROLLING || codeType === ECodeTypes.CODE_TYPE_TOP)
				)
			);
		}
		return false;
	}

	changeButtonsType(): void {
		if (this.finalType === 'KEYPAD') {
			this.finalType = this.translate.instant('KEYPAD');
		}
		if (this.finalType === 'TRANSPONDER') {
			this.finalType = this.translate.instant('TRANSPONDER');
		}
		this.buTypes.forEach(type => {
			if (this.finalType === type.Name) {
				this.f.type.setValue(type);
			}
		});
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	/* closeDialog(): void {
		//this.dialogRef.close();
		const invalid = [];
		  const controls = this.boardUserForm.controls;
		  for (const name in controls) {
				if (controls[name].invalid) {
					 invalid.push(name);
				}
		  }
	} */

	getCodeTypeIcon(codeType: string): string {
		if (this.activeIndex === 0) {
			switch (codeType) {
				case 'BOARD_USER':
					return 'cm-radio-controls';
				case 'KEYPAD':
					return 'cm-keypad';
				case 'TRANSPONDER':
					return 'cm-cards';
				default:
					return '';
			}
		} else if (codeType === 'BOARD_USER') {
			return 'cm-radio-controls';
		} else {
			return '';
		}
	}

	getCodeTypeIconStep(): string {
		switch (this.codeType) {
			case 'BOARD_USER':
				return 'cm-radio-controls';
			default:
				return '';
		}
	}

	getCodeType(): string {
		switch (this.codeType) {
			case 'BOARD_USER':
				return this.translate.instant('CODE_TYPE');
			/* case 'KEYPAD':
				return this.translate.instant('KEYPAD');
			case 'TRANSPONDER':
				return this.translate.instant('TRANSPONDER');
			case 'OTHERS':
				return this.translate.instant('OTHERS'); */
			default:
				return '';
		}
	}

	setCodeTypeEdit() {
		if (this.boardUser !== undefined && this.boardUser.Type !== undefined && this.buTypes !== undefined) {
			switch (this.boardUser.Type) {
				case ECodeTypes.CODE_TYPE_KEYBOARD:
					this.setCodeType('KEYPAD');
					break;
				case ECodeTypes.CODE_TYPE_TRANSPONDER:
					this.setCodeType('TRANSPONDER');
					break;
				case ECodeTypes.CODE_TYPE_TOP:
					this.setCodeType('BOARD_USER');
					break;
				case ECodeTypes.CODE_TYPE_TAM:
					this.setCodeType('BOARD_USER');
					break;
				case ECodeTypes.CODE_TYPE_ROLLING:
					this.setCodeType('BOARD_USER');
					break;
				case ECodeTypes.CODE_TYPE_TWIN_TTS_FIXED:
					this.setCodeType('BOARD_USER');
					break;
				default:
					this.setCodeType('BOARD_USER');
					this.setModelType('');
			}

			const bu = this.buTypes.find(b => b.Id === this.boardUser.Type);
			if (bu !== undefined) {
				this.setModelType(bu.Name);
			}
		} else {
			this.setCodeType('BOARD_USER');
		}
	}

	setCodeType(codeType: string) {
		this.codeType = codeType;
		if (codeType === 'BOARD_USER') {
			this.setModelType(this.modelType);
		} else if (codeType === 'OTHERS') {
			this.setOtherModelType(this.otherModelType);
		} else {
			this.finalType = codeType;
		}
		this.changeButtonsType();
	}

	secondStepAble(): boolean {
		return this.codeType === 'BOARD_USER';
	}

	getModelTypeIcon(modelType: string): string {
		switch (modelType) {
			case 'Rolling code':
				return 'cm-radio-control-rolling-code';
			case 'TOP':
				return 'cm-radio-control-top';
			case 'TAM':
				return 'cm-radio-control-tam';
			case 'Twin':
				return 'cm-radio-control-twin';
			case 'New Fixed Code':
				return 'cm-radio-control-fix-code';
			default:
				return '';
		}
	}

	setModelType(modelType: string) {
		const filt = this.buTypes.filter(bu => bu.Name === modelType);
		if (filt !== undefined && filt.length > 0) {
			this.f.type.setValue(filt[0]);
		}
		this.modelType = modelType;
		this.finalType = modelType;
	}

	setOtherModelType(otherModelType: string) {
		this.otherModelType = otherModelType;
		this.finalType = otherModelType;
	}

	codesTypeButtonColor(codeType: string): string {
		return (codeType === this.codeType) ? "bg-primary hover:bg-primary" : "text-color surface-100 hover:surface-500";
	}

	modelTypeButtonColor(modelType: string): string {
		return (modelType === this.modelType) ? "bg-primary hover:bg-primary" : "text-color surface-100 hover:surface-500";
	}

	otherModelTypeButtonColor(otherModelType: string): string {
		return (otherModelType === this.otherModelType) ? "bg-primary hover:bg-primary" : "text-color surface-100 hover:surface-500";
	}

	disableListCommand(buItems: any[]): void {
		for (const c of buItems) {
			c.inactive = this.disabledCommandsAutomations(c);
		}
	}

	disabledCommandsAutomations(command: any): boolean {
		if (command.CommandId < 256) {
			return false;
		} else {
			return this.checkSelectedCommandAutomation(command);
		}
	}

	checkSelectedCommandAutomation(command: any): boolean {
		if (this.f.modeBitmask.value !== undefined && this.f.modeBitmask.value.length > 0) {
			for (const c of this.f.modeBitmask.value) {
				if (RBE_24_COMMAND_ID_AUTOMATION_1.includes(c) && RBE_24_COMMAND_ID_AUTOMATION_1.includes(command.Value)
					&& c !== command.Value) {
					return true;
				}
				if (RBE_24_COMMAND_ID_AUTOMATION_2.includes(c) && RBE_24_COMMAND_ID_AUTOMATION_2.includes(command.Value)
					&& c !== command.Value) {
					return true;
				}
				if (RBE_24_COMMAND_ID_AUTOMATION_3.includes(c) && RBE_24_COMMAND_ID_AUTOMATION_3.includes(command.Value)
					&& c !== command.Value) {
					return true;
				}
				if (RBE_24_COMMAND_ID_AUTOMATION_4.includes(c) && RBE_24_COMMAND_ID_AUTOMATION_4.includes(command.Value)
					&& c !== command.Value) {
					return true;
				}
			}
		}
		return false;
	}

	isTemporary(boardUser: BoardUser): boolean {
		if ((boardUser.State & (1 << 10)) > 0 && boardUser.DateFrom !== undefined && boardUser.DateTo !== undefined && boardUser.DateFrom !== null && boardUser.DateTo !== null) {
			return true;
		}
		return false;
	}

	isFunctionControlAccessSuppor(): boolean {
		return this.compareVersions(this.deviceInfo.FwVersion, MINFWVER_ACSCHEDULES_RBE24);
	}

	compareVersions(ver1: string, ver2: string): boolean {
		// prevent missing versions v1 and/or v2
		if (!ver1) return false;
		if (!ver2) return true;

		const a = ver1.split('.').map(Number);
		const b = ver2.split('.').map(Number);

		const maxLength = Math.max(a.length, b.length);

		for (let i = 0; i < maxLength; i++) {
			const num1 = a[i] || 0; // if an element is missing, use 0 (default)
			const num2 = b[i] || 0;

			if (num1 > num2) return true;
			if (num1 < num2) return false;
		}

		return true; // if all parts are equal
	}

	disableModelField(fTypeValue: any): boolean {
		const ret = fTypeValue !== undefined;
		console.log(ret)
		return ret;
	}

	enableConfirmButtons(): boolean {
		return this.activeIndex > 1;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	col12ResponsiveNoPaddingCol6() {
		return StandardPageLayout.col6ResponsiveNoPadding(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: BoardUserDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorsConfirmFields(type: BoardUserDialogComponent["f"], classType: string, notEquivalentType: string): string {
		return StandardNewValidator.showErrorsConfirmFields(type, classType, notEquivalentType, this.screenWidth, this.boardUserForm);
	}

	showErrorRequiredMessage(type: BoardUserDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	showErrorConfirmInvalidMessage(type: BoardUserDialogComponent["f"], notEquivalentType: string): boolean {
		return StandardNewValidator.showErrorConfirmInvalidMessage(type, notEquivalentType, this.boardUserForm);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-30rem');
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

}